<template>
  <div>
    <vs-popup title="Crear grupo" :active.sync="popupActive">
      <CreateGroup v-model="group" />
    </vs-popup>
  </div>
</template>

<script>
import CreateGroup from "../../../Groups/newGroupForm.vue";
export default {
  props: ["active"],
  data() {
    return {
      group: {
        key: "",
        name: ""
      }
    };
  },
  watch: {
    group(newValue, oldValue) {
      this.$emit("groupCreate", newValue);
      this.popupActive = false;
    }
  },
  components: { CreateGroup },
  computed: {
    popupActive: {
      get() {
        return this.active;
      },
      set(value) {
        this.$emit("newValue", value);
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
